import React from 'react';
import { Link } from 'react-router-dom';
import './style/course.scss';

export default function CourseOutline({ course, courseId, currentPageId }) {
  return (
    <div className="course-outline">
      {[...course.pages].sort((a, b) => a.number - b.number).map(unit => (
        <section className="course-outline__unit" key={unit.number}>
          <h2 className="course-outline__title">Unit {unit.number}: {unit.title}</h2>
          <ol className="course-outline__pages">
            {[...unit.pages].sort((a, b) => a.number - b.number).map(page => (
              <li className="course-outline__lecture" key={page.id} value={page.number}>
                <Link to={`/lecture?courseId=${encodeURIComponent(courseId)}&pageId=${encodeURIComponent(page.id)}`}
                  aria-current={currentPageId === page.id ? 'page' : undefined}>
                  {page.title}
                </Link>
              </li>
            ))}
          </ol>
        </section>
      ))}
      {course.pages.length === 0 && <p>No lessons yet.</p>}
    </div>
  );
}
